import { FC, useContext } from "react";

import { AuthContext } from "src/context/authContext";
import { QueryParams } from "./types";
import { format } from "date-fns";




const BAAContent: FC<QueryParams> = ({ practice_address, practice_created_at, practice_name }): JSX.Element => {
  const { userData } = useContext(AuthContext)

  return (
    <>
      <div className="p-0" style={{ fontFamily: "Arial, sans-serif" }}>
        <h1 className="text-center m-4">BUSINESS ASSOCIATE AGREEMENT</h1>
        <p>
          This BUSINESS ASSOCIATE AGREEMENT (this “Agreement”) is entered into
          as of <strong>
            {userData && userData.practice_created_date && userData.practice_created_date.length > 0 && format(userData?.practice_created_date, "MM/dd/yyyy")}
            {!userData && practice_created_at && practice_created_at.length > 0 ? format(practice_created_at, "MM/dd/yyyy") : "[ ]"}
          </strong>  (the “Effective Date”), by and between  <strong>
            {userData && userData.practice_name && userData.practice_name}
            {!userData && practice_name ? practice_name : "[ ]"}
          </strong>{' '}
          (“Covered Entity”) with an address of{' '}
          <strong>
            {userData && userData.address && userData.address}
            {!userData && practice_address ? practice_address: "[ ]"}
          </strong>{' '}
          and COPILOT Provider Support Services
          (“Business Associate”) with an address of 601 S Lake Destiny Rd.
          Maitland, FL 32751.
        </p>

        <p>
          WHEREAS, User (or "COVERED ENTITY/CE" for purposes of this Section of
          this Agreement) may provide health and/or counseling services and
          maintains certain confidential protected health information ("PHI")
          and records in written and electronic form concerning its clients;
        </p>

        <p>
          WHEREAS, COPILOT Provider Support Services, Inc. “CPS” (or “BUSINESS
          ASSOCIATE/BA” for purposes of this Section of this Agreement)
          provides, Internet-based case management services to health clinicians
          and has agreed to provide use of the system to CE;
        </p>

        <p>
          WHEREAS, CE and BA are committed to conducting all of their business
          in compliance with all applicable federal, state and local statutes,
          regulations, rules and policies, including but not limited to, the
          Health Insurance Portability and Accountability Act of 1996 privacy
          rule and regulations enacted under its mandate, including all changes
          and amendments of HIPAA Privacy and Security Rules caused by the
          enactment of the Health Information Technology for Economic and
          Clinical Health Act (“HITECH”) as part of the American Recovery and
          Reinvestment Act of 2009 and relevant rules and regulations
          (collectively “the HIPAA rules”);
        </p>

        <p>
          WHEREAS, in the course of the performance of the Services, BA, and its
          shareholders, directors, officers, and employees, sub-contractors, and
          agents (the “Agents”), will be provided with access to individually
          identifiable health information, including demographic information,
          collected from individuals, or otherwise created or received by CE
          which relates to the past, present or future health or condition of
          such individuals, the provision of health care to such individuals, or
          the past, present, or future payment for the provision of health care
          to an individual, which information identifies such individuals or
          with respect to which there is a reasonable basis upon which to
          believe that the information can be used to identify such individuals
          (collectively, the “Protected Health Information” or “PHI”);
        </p>

        <p>
          WHEREAS, BA may also be provided access to electronic PHI (“EPHI”), as
          defined in HIPAA, in the course of performing the Services; and
        </p>

        <p>
          WHEREAS, CE is willing to provide BA and its Agents with access to PHI
          and EPHI such that BA can perform the Services, provided BA executes
          and complies with this Agreement, as required by the HIPAA Rules:
        </p>

        <h2>Definitions</h2>
        <p>
          Capitalized terms herein shall have the specific meaning assigned
          within this Agreement or, if no meaning is assigned herein, the
          meaning set forth in HIPAA.
        </p>

        <h2>Permitted and Required Uses and Disclosures</h2>
        <p>
          BA agrees to use and/or disclose PHI and EPHI received from, or
          created or received on behalf of, CE only as is necessary for the
          purpose of adequately rendering the Services for CE, except as herein
          otherwise permitted.
        </p>

        <h2>General Privacy and Security Compliance</h2>
        <p>
          BA shall maintain and safeguard the privacy, security and
          confidentiality of all PHI and the confidentiality, availability, and
          integrity of all EPHI received from, or created or received by BA on
          behalf of CE, in connection with the provision of the Services, in
          accordance with the provisions of HIPAA, as amended, and in accordance
          with all applicable federal, state and local statutes, regulations and
          policies regarding the confidentiality of health information.
        </p>

        <h2>Privacy and Security Obligations</h2>
        <p>As required by HIPAA and/or HITECH, BA will:</p>
        <ul>
          <li>
            Not use or further disclose PHI or EPHI other than as permitted or
            required by this Agreement and HIPAA, for performance of the
            Services;
          </li>
          <li>
            Use appropriate safeguards to prevent the use or disclosure of PHI
            and EPHI other than as permitted or required by this Agreement and
            HIPAA for performance of the Services, or as required by law;
          </li>
          <li>
            Use administrative, physical and technical safeguards to reasonably
            and appropriately protect the confidentiality, integrity and
            availability of EPHI;
          </li>
          <li>
            Promptly report to CE any use or disclosure of PHI not permitted or
            required by this Agreement for performance of the Services, or as
            required by law, or any Security Incident regarding EPHI, as
            contemplated in HIPAA, of which BA becomes aware;
          </li>
          <li>
            Notify CE in the event BA discovers an unauthorized acquisition,
            access, use or disclosure (collectively “Breach”) of Unsecured PHI
            (“PHI”) by any person, including employees and Agents of BA;
          </li>
          <li>
            Be responsible for demonstrating that such notification to CE was
            properly made in light of the fact that any Breach is considered
            “discovered” as of the first day on which such Breach becomes known
            to BA;
          </li>
          <li>
            Ensure that any Agents, including subcontractors of BA or of any
            Agent, if any, to whom BA or CE provides PHI or EPHI received from,
            or created or received by the BA on behalf of, CE agree in writing
            to the same restrictions and conditions that apply to BA with
            respect to such PHI and EPHI;
          </li>
          <li>
            Make available to CE, PHI and/or EPHI for inspection and copying in
            accordance with Section 164.524 of HIPAA (45 CFR 164.524) or for
            electronic transmission as contemplated in HITECH where BA or CE
            maintains an Electronic Health Record (“EHR”);
          </li>
          <li>
            Make available to CE, PHI for amendment and incorporate any
            amendments to PHI, if appropriate, in accordance with Section
            164.526 of HIPAA (45 CFR 164.526);
          </li>
          <li>
            Make available to CE information in its possession required to
            provide an accounting of disclosures to participants in accordance
            with Section 164.528 of HIPAA (45 CFR 164.528);
          </li>
          <li>
            Make BA’s internal practices, books and records relating to the use
            and disclosure of PHI received from, or created or received by the
            BA on behalf of, CE available to the Secretary of Health and Human
            Services (“HHS”) for purposes of determining CE’s compliance with
            HIPAA;
          </li>
          <li>
            At termination of this Agreement, extend the protections of this
            Agreement to the PHI and EPHI which will be retained by BA and limit
            further uses and disclosures to those purposes authorized by the
            HIPAA rules and this agreement.
          </li>
        </ul>

        <h2>Other Uses and Disclosures</h2>
        <p>
          Unless otherwise expressly limited by this Agreement, BA may also:
        </p>
        <ul>
          <li>
            Use PHI and EPHI for the proper management and administration of BA
            or to carry out the legal responsibilities of BA;
          </li>
          <li>
            Disclose PHI and EPHI for the proper management and administration
            of BA, provided that such disclosures are required by law or that BA
            obtains reasonable assurances from the person to whom the
            information is disclosed that the PHI and EPHI will remain
            confidential and will be used or further disclosed only as required
            by law or for the purpose for which it was disclosed to that person;
          </li>
          <li>
            Use PHI and EPHI to provide Data Aggregation services as permitted
            by 45 CFR 164.504(e)(2)(i)(B).
          </li>
        </ul>

        <h2>Obligations of CE</h2>
        <p>
          CE shall notify its PATIENTS and BA of its privacy practices and
          restrictions as follows:
        </p>
        <ul>
          <li>
            Provide BA with a Notice of Privacy Practices that CE produces in
            accordance with 45 CFR 164.520, and distributes to its patients, as
            well as any changes to such Notice;
          </li>
          <li>
            Provide BA with any changes in or revocation of permission by any
            individual to use or disclose PHI if such changes may affect BA’S
            permitted and required uses and disclosures under this Agreement;
          </li>
          <li>
            Notify BA of any restriction on the use or disclosure of PHI that CE
            may agree to in accordance with Section 164.522 of HIPAA, if such
            agreement may affect BA’S permitted or required uses and disclosures
            under this Agreement;
          </li>
          <li>
            CE shall not request BA to use or disclose PHI or EPHI in any manner
            that would not be permissible under HIPAA if done by CE;
          </li>
          <li>
            CE shall be solely responsible for making any decisions regarding,
            and for all administrative actions concerning, the exercise of any
            individual’s rights, under Sections 164.524 through 164.528 of the
            HIPAA rules.
          </li>
        </ul>

        <h2>De-Identification</h2>
        <p>
          Notwithstanding anything herein to the contrary, BA may store,
          analyze, access and use components of PHI and EPHI that have been
          “De-identified” as defined by the HIPAA rules, and that do not contain
          individually identifiable health information, provided that any such
          use is then consistent with applicable law.
        </p>

        <h2>Breach of Agreement; Termination</h2>
        <p>
          In the event that either party becomes aware of an act or omission of
          the other party that constitutes a material breach or violation of the
          parties’ obligations under this Agreement, which breach is not cured
          within fifteen (15) days after notice is provided to the breaching
          party, this Agreement may be terminated by the non-breaching party for
          cause.
        </p>

        <p>
          IN WITNESS WHEREOF, each of the undersigned has caused this Business
          Associate Agreement to be duly executed effective as of the Effective
          Date.
        </p>

        <div className="row">
          <div className="col-12 col-md-6">
            <h6 className="mb-4 mt-4">[COVERED ENTITY]</h6>
            <p>By: ________________________________</p>
            <p>Name: ______________________________</p>
            <p>Title: ______________________________</p>
            <p>Date: ______________________________</p>
          </div>

          <div className="col-12 col-md-6">
            <h6 className="mb-4 mt-4">
              COPILOT PROVIDER SUPPORT SERVICES LLC.
            </h6>
            <p>By: ________________________________</p>
            <p>Name: ______________________________</p>
            <p>Title: ______________________________</p>
            <p>Date: ______________________________</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default BAAContent;
